import Helpers from '@Apis/helpers';
import { entityNameEnum } from '@Apis/constants';

export const initialState = {
  showNewGrnForm: false,
  showDCDrawer: false,
  openGRNModalView: false,
  openDCModalView: false,
  selectedGRN: null,
  selectedDC: null,
  isUserReady: false,
  isUserReadyForPrefillData: false,
  isGetAttachment: false,
  fileList: [],
  cfStockTransferLine: [],
  visibleColumns: {
    PRODUCT: { label: 'PRODUCT', visible: true, disabled: true },
    HSN: { label: 'HSN/SAC CODE', visible: true, disabled: true },
    TRANSFER_QTY: { label: 'TRANSFER QTY', visible: true, disabled: true },
    RECEIVED_QTY: { label: 'RECEIVED QTY', visible: true, disabled: true },
    SHORT_CLOSE_QTY: { label: 'SHORT CLOSE QTY', visible: true, disabled: true },
    LOCATION: { label: 'LOCATION', visible: true, disabled: true },
  }
};

export const getLinkedDocumentInfo = ({
  selectedSt,
  user,
  isQuickView,
  openGRNModalView,
  openDCModalView,
  setState
}) => {
  const linkedDocumentsInfo = [];

  if (selectedSt?.reference_grn?.length > 0) {
    const documentDataInfo = selectedSt.reference_grn.map(item => ({
      documentId: item?.grn_id,
      documentNumber: item?.grn_number,
      documentStatus: item?.status,
    }));

    linkedDocumentsInfo.push({
      entityName: entityNameEnum.GOOD_RECEIVING_NOTE,
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ, user)
        && selectedSt.status === 'ISSUED',
      title: 'GOODS RECEIVED',
      entityNumberPrefix: 'GRN',
      documentData: documentDataInfo,
      isDrawer: !isQuickView,
      isRedirect: isQuickView,
      redirectPath: '/purchase/goods-receiving/view/',
      drawerState: openGRNModalView,
      drawerCallback: (grn, isOpen) => setState(prev => ({ ...prev, selectedGRN: grn?.documentId, openGRNModalView: isOpen })),
    });
  }

  if (selectedSt?.reference_dc?.length > 0) {
    const documentDataInfo = selectedSt.reference_dc.map(item => ({
      documentId: item?.delivery_challan_id,
      documentNumber: item?.dc_number,
      documentStatus: item?.status,
    }));

    linkedDocumentsInfo.push({
      entityName: entityNameEnum.DELIVERY_CHALLAN,
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ, user)
        && selectedSt.status === 'ISSUED',
      title: 'DELIVERY CHALLANS',
      entityNumberPrefix: 'DC',
      documentData: documentDataInfo,
      isDrawer: !isQuickView,
      isRedirect: isQuickView,
      redirectPath: '/purchase/goods-receiving/view/',
      drawerState: openDCModalView,
      drawerCallback: (dc, isOpen) => setState(prev => ({ ...prev, selectedDC: dc?.documentId, openDCModalView: isOpen })),
    });
  }

  return linkedDocumentsInfo;
};

export const getStockTransferType = (selectedSt, user) => {
  if (selectedSt?.source_department_info?.tenant_id === selectedSt?.destination_department_info?.tenant_id) {
    return 'Internal';
  } else if (selectedSt?.source_department_info?.tenant_id === user?.tenant_info?.tenant_id) {
    return 'Outgoing';
  } else if (selectedSt?.destination_department_info?.tenant_id === user?.tenant_info?.tenant_id) {
    return 'Incoming';
  }
  return '';
};

export const getTenantIdList = (user) =>
  Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.READ)?.join(',');

export const handleFileChangeHelper = ({ fileListData, selectedSt, updateAttachment, getAttachmentById, setState }) => {
  const fileList = fileListData?.fileList?.map((item) => ({
    ...item,
    url: item?.response?.response?.location || item?.url,
  }));

  const attachments = fileList?.map((attachment) => ({
    url: attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
  }));

  const payload = {
    entity_id: selectedSt?.stock_transfer_id,
    entity_name: 'stock_transfer',
    attachments,
  };

  if (['done', 'removed'].includes(fileListData?.file.status)) {
    updateAttachment(payload, () => {
      getAttachmentById(selectedSt?.stock_transfer_id, 'stock_transfer', () => {
        setState(prev => ({ ...prev, isGetAttachment: true }));
      });
    });
  }

  setState(prev => ({ ...prev, fileList: attachments.length > 0 ? attachments : [] }));
};